import getRegionalOptions from '../data/store/store';
import { getUserConfiguration } from 'owa-session-store';
import { select } from 'satcheljs/lib/legacy';
import CultureInfoData from 'owa-service/lib/contract/CultureInfoData';

export interface GetFilteredTimeFormatOptionsState {
    savedLocale: string;
    selectedLocale: string;
    supportedCultures: CultureInfoData[];
    supportedShortTimeFormats: string[];
}

export default select<GetFilteredTimeFormatOptionsState>({
    savedLocale: () => getUserConfiguration().SessionSettings.UserCulture,
    selectedLocale: () => getRegionalOptions().selectedLocale,
    supportedCultures: () => getRegionalOptions().supportedCultures,
    supportedShortTimeFormats: () => getRegionalOptions().supportedShortTimeFormats,
})(function getFilteredTimeFormatOptions(state?: GetFilteredTimeFormatOptionsState) {
    let selectedLocaleName = state.selectedLocale || state.savedLocale;
    let selectedLocale = state.supportedCultures.filter(
        culture => culture.Name === selectedLocaleName
    )[0];

    if (selectedLocale) {
        return state.supportedShortTimeFormats.filter(
            (shortDateFormat, index) => selectedLocale.ShortTimeFormatsIndexes.indexOf(index) >= 0
        );
    } else {
        return [];
    }
});
